import "./App.css";
import Footer from "./screens/Footer";
import Header from "./screens/Header";
import RouteList from "./screens/RouteList";
import { BrowserRouter } from "react-router-dom";
import { darkTheme, lightTheme } from "./screens/Theme";
import { ThemeProvider, CssBaseline } from "@mui/material";

function App() {
  const themeMode = "dark";
  const theme = themeMode === "light" ? lightTheme : darkTheme;
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Header />
        <RouteList></RouteList>
        <Footer />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
